import { isLightshop, isSvenssons } from 'webapp/theme';

function calcDiscountValue(price: number, discountPercent: number) {
  return price * (discountPercent / 100);
}

function calcDiscountResult(price: number, discountPercent: number) {
  return price - calcDiscountValue(price, discountPercent);
}

export function applyPercentagePrice(
  price: NordicNest.Api.PriceApiModel | Excite.Commercetools.CartPriceApiModel,
  discountPercent: number,
): NordicNest.Api.PriceApiModel | Excite.Commercetools.CartPriceApiModel {
  const calcPriceExclVat = calcDiscountResult(price.current.exclVat, discountPercent);
  const calcPriceIncVat = calcPriceExclVat + calcPriceExclVat * price.current.vatPercent;
  const roundedCalcPriceExclVat = Math.round(calcPriceExclVat);

  return { ...price, current: { ...price.current, inclVat: calcPriceIncVat, exclVat: roundedCalcPriceExclVat } };
}

export const applyImageBackground = isLightshop || isSvenssons;
